import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";

// Config
import colors from "../../config/colors";
import { getRoute, urls } from "../../config/routes";

// Actions
import { getImage } from "../../state/physicalDamage/actions";

// Components
import AddPhysicalDamageImage from "../AddPhysicalDamageImage";
import ImageItem from "../ImageItem";
import ImageProcessing from "../ImageProcessing";
import Text from "../Text";

const IMAGE_SIZE = 170;

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: theme.spacing(2)
  },
  grid: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: theme.spacing(1)
  },
  imageItem: {
    borderRadius: theme.shape.borderRadius
  },
  processingTile: {
    height: IMAGE_SIZE,
    width: IMAGE_SIZE,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.whisper,
    borderRadius: theme.shape.borderRadius
  }
}));

const PhysicalDamageImages = ({ caseId, physicalDamageId, images }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const handleClick = index => () =>
    history.push(
      getRoute(urls.physicalDamageAnnotationTool, {
        caseId,
        physicalDamageId,
        index
      })
    );

  return (
    <div>
      <Text
        className={classes.title}
        text="editInjuryPage.imagesTitle"
        type="heading4"
      />
      <div className={classes.grid}>
        {images.map((image, index) =>
          image.isProcessing ? (
            <div key={image.filename} className={classes.processingTile}>
              <ImageProcessing
                image={image}
                getImage={() =>
                  dispatch(
                    getImage({
                      caseId,
                      physicalDamageId,
                      filename: image.filename,
                      index
                    })
                  )
                }
              />
            </div>
          ) : (
            <ImageItem
              key={image.filename}
              className={classes.imageItem}
              height={IMAGE_SIZE}
              width={IMAGE_SIZE}
              image={image}
              onClick={handleClick(index)}
            />
          )
        )}
        <AddPhysicalDamageImage thumbnail images={images} />
      </div>
    </div>
  );
};

PhysicalDamageImages.propTypes = {
  caseId: PropTypes.string.isRequired,
  physicalDamageId: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      filename: PropTypes.string,
      downloadURLs: PropTypes.shape({ thumbnailURL: PropTypes.string }),
      imageType: PropTypes.string,
      isProcessing: PropTypes.bool
    })
  ).isRequired
};

export default PhysicalDamageImages;
